@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(1_608_244_461)
internal val Res.string.promo_form_preview_referrer: StringResource by lazy {
      StringResource("string:promo_form_preview_referrer", "promo_form_preview_referrer", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44295, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44471, 139),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44007, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41355, 139),
      ))
    }

@delegate:ResourceContentHash(-1_357_848_355)
internal val Res.string.promo_form_referral: StringResource by lazy {
      StringResource("string:promo_form_referral", "promo_form_referral", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44607, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44767, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44327, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41647, 59),
      ))
    }

@delegate:ResourceContentHash(-363_058_437)
internal val Res.string.promo_form_referral_help: StringResource by lazy {
      StringResource("string:promo_form_referral_help", "promo_form_referral_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44498, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44658, 108),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44218, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41542, 104),
      ))
    }

@delegate:ResourceContentHash(-1_815_450_871)
internal val Res.string.promo_form_referrer_email: StringResource by lazy {
      StringResource("string:promo_form_referrer_email", "promo_form_referrer_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44679, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44839, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44399, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41707, 53),
      ))
    }

@delegate:ResourceContentHash(-1_381_481_288)
internal val Res.string.promo_form_referrer_help: StringResource by lazy {
      StringResource("string:promo_form_referrer_help", "promo_form_referrer_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44737, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44897, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44457, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41761, 76),
      ))
    }

@delegate:ResourceContentHash(-2_029_558_452)
internal val Res.string.promo_form_rename_warning: StringResource by lazy {
      StringResource("string:promo_form_rename_warning", "promo_form_rename_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 44814, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 44970, 173),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44538, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41838, 145),
      ))
    }

@delegate:ResourceContentHash(1_376_667_895)
internal val Res.string.promo_form_used_banner: StringResource by lazy {
      StringResource("string:promo_form_used_banner", "promo_form_used_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45000, 206),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45144, 218),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44708, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41984, 170),
      ))
    }

@delegate:ResourceContentHash(-2_044_580_389)
internal val Res.string.promo_referrer: StringResource by lazy {
      StringResource("string:promo_referrer", "promo_referrer", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45395, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45551, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45091, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42335, 42),
      ))
    }

@delegate:ResourceContentHash(-1_392_881_498)
internal val Res.string.promo_referrer_commission: StringResource by lazy {
      StringResource("string:promo_referrer_commission", "promo_referrer_commission", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45207, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45363, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44907, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42155, 57),
      ))
    }

@delegate:ResourceContentHash(186_086_357)
internal val Res.string.promo_referrer_locked: StringResource by lazy {
      StringResource("string:promo_referrer_locked", "promo_referrer_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45265, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45421, 129),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 44965, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42213, 121),
      ))
    }

@delegate:ResourceContentHash(-104_876_558)
internal val Res.string.promo_retry: StringResource by lazy {
      StringResource("string:promo_retry", "promo_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45438, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45594, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45134, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42378, 27),
      ))
    }

@delegate:ResourceContentHash(-1_684_937_314)
internal val Res.string.promo_save: StringResource by lazy {
      StringResource("string:promo_save", "promo_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45782, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45922, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45478, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42678, 26),
      ))
    }

@delegate:ResourceContentHash(-829_333_721)
internal val Res.string.promo_save_error_network: StringResource by lazy {
      StringResource("string:promo_save_error_network", "promo_save_error_network", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45474, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45630, 120),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45178, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42406, 100),
      ))
    }

@delegate:ResourceContentHash(544_015_157)
internal val Res.string.promo_save_error_not_found: StringResource by lazy {
      StringResource("string:promo_save_error_not_found", "promo_save_error_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45595, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45751, 98),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45299, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42507, 98),
      ))
    }

@delegate:ResourceContentHash(-1_472_317_789)
internal val Res.string.promo_save_error_server: StringResource by lazy {
      StringResource("string:promo_save_error_server", "promo_save_error_server", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45702, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45850, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45406, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42606, 71),
      ))
    }

@delegate:ResourceContentHash(264_032_837)
internal val Res.string.promo_state_active: StringResource by lazy {
      StringResource("string:promo_state_active", "promo_state_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45813, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45957, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45505, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42705, 34),
      ))
    }

@delegate:ResourceContentHash(147_688_595)
internal val Res.string.promo_state_disabled: StringResource by lazy {
      StringResource("string:promo_state_disabled", "promo_state_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45848, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 45992, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45540, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42740, 40),
      ))
    }

@delegate:ResourceContentHash(-224_010_162)
internal val Res.string.promo_state_exhausted: StringResource by lazy {
      StringResource("string:promo_state_exhausted", "promo_state_exhausted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45893, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46037, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45585, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42781, 41),
      ))
    }

@delegate:ResourceContentHash(1_435_680_920)
internal val Res.string.promo_state_expired: StringResource by lazy {
      StringResource("string:promo_state_expired", "promo_state_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45935, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46079, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45627, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42823, 39),
      ))
    }

@delegate:ResourceContentHash(1_186_324_837)
internal val Res.string.promo_stripe_badge: StringResource by lazy {
      StringResource("string:promo_stripe_badge", "promo_stripe_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 45975, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46119, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45667, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42863, 50),
      ))
    }

@delegate:ResourceContentHash(1_842_897_340)
internal val Res.string.promo_toast_deleted: StringResource by lazy {
      StringResource("string:promo_toast_deleted", "promo_toast_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46030, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46178, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45722, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42914, 51),
      ))
    }

@delegate:ResourceContentHash(-1_216_921_175)
internal val Res.string.promo_toast_disabled: StringResource by lazy {
      StringResource("string:promo_toast_disabled", "promo_toast_disabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46090, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46234, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45782, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42966, 52),
      ))
    }

@delegate:ResourceContentHash(2_078_041_431)
internal val Res.string.promo_toast_enabled: StringResource by lazy {
      StringResource("string:promo_toast_enabled", "promo_toast_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46151, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46291, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45843, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43019, 51),
      ))
    }

@delegate:ResourceContentHash(983_757_338)
internal val Res.string.promo_undo: StringResource by lazy {
      StringResource("string:promo_undo", "promo_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46211, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46347, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45903, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43071, 26),
      ))
    }

@delegate:ResourceContentHash(380_385_977)
internal val Res.string.promo_uses: StringResource by lazy {
      StringResource("string:promo_uses", "promo_uses", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46299, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46447, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46003, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43155, 42),
      ))
    }

@delegate:ResourceContentHash(-549_125_672)
internal val Res.string.promo_uses_unlimited: StringResource by lazy {
      StringResource("string:promo_uses_unlimited", "promo_uses_unlimited", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46242, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46378, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 45934, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43098, 56),
      ))
    }

@delegate:ResourceContentHash(933_647_777)
internal val Res.string.promo_valid_forever: StringResource by lazy {
      StringResource("string:promo_valid_forever", "promo_valid_forever", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46342, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46498, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46058, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43198, 43),
      ))
    }

@delegate:ResourceContentHash(-1_200_960_100)
internal val Res.string.promo_valid_until: StringResource by lazy {
      StringResource("string:promo_valid_until", "promo_valid_until", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46394, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46550, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46106, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43242, 41),
      ))
    }

@delegate:ResourceContentHash(-1_480_900_743)
internal val Res.string.report_analysis_period: StringResource by lazy {
      StringResource("string:report_analysis_period", "report_analysis_period", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46440, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46596, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46144, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43284, 50),
      ))
    }

@delegate:ResourceContentHash(-182_488_820)
internal val Res.string.report_detected_strikes: StringResource by lazy {
      StringResource("string:report_detected_strikes", "report_detected_strikes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46499, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46651, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46203, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43335, 67),
      ))
    }

@delegate:ResourceContentHash(-580_095_166)
internal val Res.string.report_generated_via: StringResource by lazy {
      StringResource("string:report_generated_via", "report_generated_via", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46567, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46723, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46271, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43403, 64),
      ))
    }

@delegate:ResourceContentHash(-1_684_063_984)
internal val Res.string.report_interpretation_gld: StringResource by lazy {
      StringResource("string:report_interpretation_gld", "report_interpretation_gld", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46632, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46788, 81),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46332, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43468, 73),
      ))
    }

@delegate:ResourceContentHash(-914_107_130)
internal val Res.string.report_keraunic_title: StringResource by lazy {
      StringResource("string:report_keraunic_title", "report_keraunic_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46706, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46870, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46406, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43542, 49),
      ))
    }

@delegate:ResourceContentHash(-765_162_073)
internal val Res.string.report_negative: StringResource by lazy {
      StringResource("string:report_negative", "report_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46760, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46928, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46464, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43592, 35),
      ))
    }

@delegate:ResourceContentHash(-502_736_031)
internal val Res.string.report_positive: StringResource by lazy {
      StringResource("string:report_positive", "report_positive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46796, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46964, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46500, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43628, 35),
      ))
    }

@delegate:ResourceContentHash(-160_957_314)
internal val Res.string.report_share_title: StringResource by lazy {
      StringResource("string:report_share_title", "report_share_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46832, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47000, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46536, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43664, 58),
      ))
    }

@delegate:ResourceContentHash(-857_500_928)
internal val Res.string.report_total: StringResource by lazy {
      StringResource("string:report_total", "report_total", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46895, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47067, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46603, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43723, 28),
      ))
    }

@delegate:ResourceContentHash(-746_655_666)
internal val Res.string.result: StringResource by lazy {
      StringResource("string:result", "result", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46924, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47096, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46632, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43752, 22),
      ))
    }

@delegate:ResourceContentHash(-104_876_558)
internal val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46951, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47123, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46659, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43775, 21),
      ))
    }

@delegate:ResourceContentHash(2_096_001_329)
internal val Res.string.scenario_name: StringResource by lazy {
      StringResource("string:scenario_name", "scenario_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 46981, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47153, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46697, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43797, 41),
      ))
    }

@delegate:ResourceContentHash(1_968_958_097)
internal val Res.string.select: StringResource by lazy {
      StringResource("string:select", "select", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47147, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47319, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46855, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43939, 22),
      ))
    }

@delegate:ResourceContentHash(759_907_010)
internal val Res.string.select_hint: StringResource by lazy {
      StringResource("string:select_hint", "select_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47071, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47239, 79),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46783, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43875, 63),
      ))
    }

@delegate:ResourceContentHash(-639_080_917)
internal val Res.string.select_hint_dismiss: StringResource by lazy {
      StringResource("string:select_hint_dismiss", "select_hint_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47031, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47195, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46743, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43839, 35),
      ))
    }

@delegate:ResourceContentHash(1_518_687_095)
internal val Res.string.settings_alert_radius_label: StringResource by lazy {
      StringResource("string:settings_alert_radius_label", "settings_alert_radius_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47178, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47354, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46886, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43962, 51),
      ))
    }

@delegate:ResourceContentHash(-1_084_263_863)
internal val Res.string.settings_alerts_enabled: StringResource by lazy {
      StringResource("string:settings_alerts_enabled", "settings_alerts_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47234, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47410, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46942, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44014, 51),
      ))
    }

@delegate:ResourceContentHash(-1_208_296_900)
internal val Res.string.settings_alerts_title: StringResource by lazy {
      StringResource("string:settings_alerts_title", "settings_alerts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47290, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47466, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 46998, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44066, 53),
      ))
    }

@delegate:ResourceContentHash(1_796_977_068)
internal val Res.string.settings_language_label: StringResource by lazy {
      StringResource("string:settings_language_label", "settings_language_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47344, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47516, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47052, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44120, 43),
      ))
    }

@delegate:ResourceContentHash(-1_939_434_328)
internal val Res.string.settings_notifications_title: StringResource by lazy {
      StringResource("string:settings_notifications_title", "settings_notifications_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47384, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47556, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47092, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44164, 56),
      ))
    }

@delegate:ResourceContentHash(553_790_515)
internal val Res.string.settings_plan_label: StringResource by lazy {
      StringResource("string:settings_plan_label", "settings_plan_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47441, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47613, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47149, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44221, 35),
      ))
    }

@delegate:ResourceContentHash(446_998_635)
internal val Res.string.settings_profile_title: StringResource by lazy {
      StringResource("string:settings_profile_title", "settings_profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47477, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47653, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47185, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44257, 42),
      ))
    }

@delegate:ResourceContentHash(1_072_560_839)
internal val Res.string.settings_push_notifications: StringResource by lazy {
      StringResource("string:settings_push_notifications", "settings_push_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47516, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47692, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47224, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44300, 59),
      ))
    }

@delegate:ResourceContentHash(199_519_352)
internal val Res.string.share_document: StringResource by lazy {
      StringResource("string:share_document", "share_document", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47580, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47752, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47288, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44360, 30),
      ))
    }

@delegate:ResourceContentHash(1_483_069_794)
internal val Res.string.share_email: StringResource by lazy {
      StringResource("string:share_email", "share_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47615, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47787, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47327, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44391, 39),
      ))
    }

@delegate:ResourceContentHash(-1_305_912_610)
internal val Res.string.share_title_cert_nsg: StringResource by lazy {
      StringResource("string:share_title_cert_nsg", "share_title_cert_nsg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47675, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47831, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47371, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44431, 72),
      ))
    }

@delegate:ResourceContentHash(1_140_138_046)
internal val Res.string.share_title_cert_thunder: StringResource by lazy {
      StringResource("string:share_title_cert_thunder", "share_title_cert_thunder", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47748, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47904, 88),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47444, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44504, 92),
      ))
    }

@delegate:ResourceContentHash(1_384_534_790)
internal val Res.string.share_title_report: StringResource by lazy {
      StringResource("string:share_title_report", "share_title_report", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47845, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 47993, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47541, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44597, 70),
      ))
    }

@delegate:ResourceContentHash(-1_709_764_381)
internal val Res.string.share_via: StringResource by lazy {
      StringResource("string:share_via", "share_via", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47916, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48068, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47640, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44668, 33),
      ))
    }

@delegate:ResourceContentHash(576_824_152)
internal val Res.string.show_scenario_delete_text: StringResource by lazy {
      StringResource("string:show_scenario_delete_text", "show_scenario_delete_text", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 47958, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48106, 85),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47686, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44702, 85),
      ))
    }

@delegate:ResourceContentHash(1_456_899_359)
internal val Res.string.show_scenario_delete_title: StringResource by lazy {
      StringResource("string:show_scenario_delete_title", "show_scenario_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48064, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48192, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47784, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44788, 62),
      ))
    }

@delegate:ResourceContentHash(1_573_913_797)
internal val Res.string.sondes_count: StringResource by lazy {
      StringResource("string:sondes_count", "sondes_count", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48127, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48255, 52),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47843, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44851, 48),
      ))
    }

@delegate:ResourceContentHash(-1_942_098_754)
internal val Res.string.sondes_covered_site: StringResource by lazy {
      StringResource("string:sondes_covered_site", "sondes_covered_site", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48176, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48308, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47892, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44900, 51),
      ))
    }

@delegate:ResourceContentHash(-1_457_276_262)
internal val Res.string.sondes_filter_status: StringResource by lazy {
      StringResource("string:sondes_filter_status", "sondes_filter_status", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48232, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48364, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47948, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44952, 36),
      ))
    }

@delegate:ResourceContentHash(1_565_608_272)
internal val Res.string.sondes_no_match: StringResource by lazy {
      StringResource("string:sondes_no_match", "sondes_no_match", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48269, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48401, 111),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 47985, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44989, 91),
      ))
    }

@delegate:ResourceContentHash(947_316_207)
internal val Res.string.sondes_reset: StringResource by lazy {
      StringResource("string:sondes_reset", "sondes_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48373, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48513, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48089, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45081, 28),
      ))
    }

@delegate:ResourceContentHash(305_602_905)
internal val Res.string.sondes_search_hint: StringResource by lazy {
      StringResource("string:sondes_search_hint", "sondes_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48410, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48554, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48118, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45110, 74),
      ))
    }

@delegate:ResourceContentHash(1_952_311_738)
internal val Res.string.sondes_sort_by: StringResource by lazy {
      StringResource("string:sondes_sort_by", "sondes_sort_by", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48489, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48637, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48201, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45185, 34),
      ))
    }

@delegate:ResourceContentHash(619_842_204)
internal val Res.string.sondes_sort_name: StringResource by lazy {
      StringResource("string:sondes_sort_name", "sondes_sort_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48528, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48672, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48240, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45220, 40),
      ))
    }

@delegate:ResourceContentHash(-932_225_453)
internal val Res.string.sondes_sort_recent: StringResource by lazy {
      StringResource("string:sondes_sort_recent", "sondes_sort_recent", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48569, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48709, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48281, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45261, 42),
      ))
    }

@delegate:ResourceContentHash(-1_560_232_153)
internal val Res.string.sondes_sort_sites: StringResource by lazy {
      StringResource("string:sondes_sort_sites", "sondes_sort_sites", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48616, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48756, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48324, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45304, 49),
      ))
    }

@delegate:ResourceContentHash(264_626_735)
internal val Res.string.sondes_status_active: StringResource by lazy {
      StringResource("string:sondes_status_active", "sondes_status_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48718, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48862, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48422, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45398, 36),
      ))
    }

@delegate:ResourceContentHash(-721_076_781)
internal val Res.string.sondes_status_active_plural: StringResource by lazy {
      StringResource("string:sondes_status_active_plural", "sondes_status_active_plural", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48670, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48814, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48378, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45354, 43),
      ))
    }

@delegate:ResourceContentHash(1_932_253_645)
internal val Res.string.sondes_status_all: StringResource by lazy {
      StringResource("string:sondes_status_all", "sondes_status_all", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48755, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48899, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48459, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45435, 29),
      ))
    }

@delegate:ResourceContentHash(-1_499_431_560)
internal val Res.string.sondes_status_inactive: StringResource by lazy {
      StringResource("string:sondes_status_inactive", "sondes_status_inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48839, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48983, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48543, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45515, 42),
      ))
    }

@delegate:ResourceContentHash(-1_496_378_463)
internal val Res.string.sondes_status_inactive_plural: StringResource by lazy {
      StringResource("string:sondes_status_inactive_plural", "sondes_status_inactive_plural", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48789, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 48933, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48493, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45465, 49),
      ))
    }

@delegate:ResourceContentHash(-436_875_320)
internal val Res.string.strike_date: StringResource by lazy {
      StringResource("string:strike_date", "strike_date", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48882, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49026, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48586, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45558, 27),
      ))
    }

@delegate:ResourceContentHash(2_092_488_247)
internal val Res.string.strike_distance: StringResource by lazy {
      StringResource("string:strike_distance", "strike_distance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48910, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49054, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48614, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45586, 35),
      ))
    }

@delegate:ResourceContentHash(-2_100_577_659)
internal val Res.string.strike_incidence_probability: StringResource by lazy {
      StringResource("string:strike_incidence_probability", "strike_incidence_probability", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 48946, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49090, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48654, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45622, 64),
      ))
    }

@delegate:ResourceContentHash(648_951_885)
internal val Res.string.strike_intensity: StringResource by lazy {
      StringResource("string:strike_intensity", "strike_intensity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49019, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49159, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48731, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45687, 36),
      ))
    }

@delegate:ResourceContentHash(-937_905_416)
internal val Res.string.strike_sensors: StringResource by lazy {
      StringResource("string:strike_sensors", "strike_sensors", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49060, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49200, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48772, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45724, 34),
      ))
    }

@delegate:ResourceContentHash(1_126_698_031)
internal val Res.string.strike_time_utc: StringResource by lazy {
      StringResource("string:strike_time_utc", "strike_time_utc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49095, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49235, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48807, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45759, 39),
      ))
    }

@delegate:ResourceContentHash(1_224_847_352)
internal val Res.string.time_format: StringResource by lazy {
      StringResource("string:time_format", "time_format", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49135, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49275, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48847, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45799, 55),
      ))
    }

@delegate:ResourceContentHash(1_161_238_106)
internal val Res.string.title_account: StringResource by lazy {
      StringResource("string:title_account", "title_account", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49191, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49331, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48903, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45855, 37),
      ))
    }

@delegate:ResourceContentHash(1_399_888_222)
internal val Res.string.title_activity: StringResource by lazy {
      StringResource("string:title_activity", "title_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49225, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49369, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48941, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45893, 34),
      ))
    }

@delegate:ResourceContentHash(-1_938_971_205)
internal val Res.string.title_dashboard: StringResource by lazy {
      StringResource("string:title_dashboard", "title_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49260, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49404, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 48976, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45928, 35),
      ))
    }

@delegate:ResourceContentHash(-2_004_320_288)
internal val Res.string.title_documents: StringResource by lazy {
      StringResource("string:title_documents", "title_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49308, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49448, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49008, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45964, 35),
      ))
    }

@delegate:ResourceContentHash(-1_504_886_654)
internal val Res.string.title_map: StringResource by lazy {
      StringResource("string:title_map", "title_map", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49404, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49540, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49104, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46056, 41),
      ))
    }

@delegate:ResourceContentHash(-437_495_234)
internal val Res.string.title_map_admin: StringResource by lazy {
      StringResource("string:title_map_admin", "title_map_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49348, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49484, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49048, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46000, 55),
      ))
    }

@delegate:ResourceContentHash(-356_419_905)
internal val Res.string.title_settings: StringResource by lazy {
      StringResource("string:title_settings", "title_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49446, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49582, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49146, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46098, 34),
      ))
    }

@delegate:ResourceContentHash(1_217_970_060)
internal val Res.string.top10_days_subtitle: StringResource by lazy {
      StringResource("string:top10_days_subtitle", "top10_days_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49481, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49621, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49189, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46133, 47),
      ))
    }

@delegate:ResourceContentHash(-1_336_097_523)
internal val Res.string.top10_days_title: StringResource by lazy {
      StringResource("string:top10_days_title", "top10_days_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49533, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49673, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49241, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46181, 40),
      ))
    }

@delegate:ResourceContentHash(-751_937_564)
internal val Res.string.uv_index: StringResource by lazy {
      StringResource("string:uv_index", "uv_index", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49574, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49714, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49282, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46222, 28),
      ))
    }

@delegate:ResourceContentHash(1_048_070_443)
internal val Res.string.validate: StringResource by lazy {
      StringResource("string:validate", "validate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49607, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49743, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49315, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46251, 28),
      ))
    }

@delegate:ResourceContentHash(-809_977_363)
internal val Res.string.warn_customer_text_client: StringResource by lazy {
      StringResource("string:warn_customer_text_client", "warn_customer_text_client", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49636, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49772, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49344, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46280, 69),
      ))
    }

@delegate:ResourceContentHash(966_895_109)
internal val Res.string.warn_customer_text_manager: StringResource by lazy {
      StringResource("string:warn_customer_text_manager", "warn_customer_text_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49722, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49842, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49422, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46350, 50),
      ))
    }

@delegate:ResourceContentHash(1_551_036_163)
internal val Res.string.you_are_connected: StringResource by lazy {
      StringResource("string:you_are_connected", "you_are_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49785, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 49905, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 49481, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46401, 49),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("promo_form_preview_referrer", Res.string.promo_form_preview_referrer)
  map.put("promo_form_referral", Res.string.promo_form_referral)
  map.put("promo_form_referral_help", Res.string.promo_form_referral_help)
  map.put("promo_form_referrer_email", Res.string.promo_form_referrer_email)
  map.put("promo_form_referrer_help", Res.string.promo_form_referrer_help)
  map.put("promo_form_rename_warning", Res.string.promo_form_rename_warning)
  map.put("promo_form_used_banner", Res.string.promo_form_used_banner)
  map.put("promo_referrer", Res.string.promo_referrer)
  map.put("promo_referrer_commission", Res.string.promo_referrer_commission)
  map.put("promo_referrer_locked", Res.string.promo_referrer_locked)
  map.put("promo_retry", Res.string.promo_retry)
  map.put("promo_save", Res.string.promo_save)
  map.put("promo_save_error_network", Res.string.promo_save_error_network)
  map.put("promo_save_error_not_found", Res.string.promo_save_error_not_found)
  map.put("promo_save_error_server", Res.string.promo_save_error_server)
  map.put("promo_state_active", Res.string.promo_state_active)
  map.put("promo_state_disabled", Res.string.promo_state_disabled)
  map.put("promo_state_exhausted", Res.string.promo_state_exhausted)
  map.put("promo_state_expired", Res.string.promo_state_expired)
  map.put("promo_stripe_badge", Res.string.promo_stripe_badge)
  map.put("promo_toast_deleted", Res.string.promo_toast_deleted)
  map.put("promo_toast_disabled", Res.string.promo_toast_disabled)
  map.put("promo_toast_enabled", Res.string.promo_toast_enabled)
  map.put("promo_undo", Res.string.promo_undo)
  map.put("promo_uses", Res.string.promo_uses)
  map.put("promo_uses_unlimited", Res.string.promo_uses_unlimited)
  map.put("promo_valid_forever", Res.string.promo_valid_forever)
  map.put("promo_valid_until", Res.string.promo_valid_until)
  map.put("report_analysis_period", Res.string.report_analysis_period)
  map.put("report_detected_strikes", Res.string.report_detected_strikes)
  map.put("report_generated_via", Res.string.report_generated_via)
  map.put("report_interpretation_gld", Res.string.report_interpretation_gld)
  map.put("report_keraunic_title", Res.string.report_keraunic_title)
  map.put("report_negative", Res.string.report_negative)
  map.put("report_positive", Res.string.report_positive)
  map.put("report_share_title", Res.string.report_share_title)
  map.put("report_total", Res.string.report_total)
  map.put("result", Res.string.result)
  map.put("retry", Res.string.retry)
  map.put("scenario_name", Res.string.scenario_name)
  map.put("select", Res.string.select)
  map.put("select_hint", Res.string.select_hint)
  map.put("select_hint_dismiss", Res.string.select_hint_dismiss)
  map.put("settings_alert_radius_label", Res.string.settings_alert_radius_label)
  map.put("settings_alerts_enabled", Res.string.settings_alerts_enabled)
  map.put("settings_alerts_title", Res.string.settings_alerts_title)
  map.put("settings_language_label", Res.string.settings_language_label)
  map.put("settings_notifications_title", Res.string.settings_notifications_title)
  map.put("settings_plan_label", Res.string.settings_plan_label)
  map.put("settings_profile_title", Res.string.settings_profile_title)
  map.put("settings_push_notifications", Res.string.settings_push_notifications)
  map.put("share_document", Res.string.share_document)
  map.put("share_email", Res.string.share_email)
  map.put("share_title_cert_nsg", Res.string.share_title_cert_nsg)
  map.put("share_title_cert_thunder", Res.string.share_title_cert_thunder)
  map.put("share_title_report", Res.string.share_title_report)
  map.put("share_via", Res.string.share_via)
  map.put("show_scenario_delete_text", Res.string.show_scenario_delete_text)
  map.put("show_scenario_delete_title", Res.string.show_scenario_delete_title)
  map.put("sondes_count", Res.string.sondes_count)
  map.put("sondes_covered_site", Res.string.sondes_covered_site)
  map.put("sondes_filter_status", Res.string.sondes_filter_status)
  map.put("sondes_no_match", Res.string.sondes_no_match)
  map.put("sondes_reset", Res.string.sondes_reset)
  map.put("sondes_search_hint", Res.string.sondes_search_hint)
  map.put("sondes_sort_by", Res.string.sondes_sort_by)
  map.put("sondes_sort_name", Res.string.sondes_sort_name)
  map.put("sondes_sort_recent", Res.string.sondes_sort_recent)
  map.put("sondes_sort_sites", Res.string.sondes_sort_sites)
  map.put("sondes_status_active", Res.string.sondes_status_active)
  map.put("sondes_status_active_plural", Res.string.sondes_status_active_plural)
  map.put("sondes_status_all", Res.string.sondes_status_all)
  map.put("sondes_status_inactive", Res.string.sondes_status_inactive)
  map.put("sondes_status_inactive_plural", Res.string.sondes_status_inactive_plural)
  map.put("strike_date", Res.string.strike_date)
  map.put("strike_distance", Res.string.strike_distance)
  map.put("strike_incidence_probability", Res.string.strike_incidence_probability)
  map.put("strike_intensity", Res.string.strike_intensity)
  map.put("strike_sensors", Res.string.strike_sensors)
  map.put("strike_time_utc", Res.string.strike_time_utc)
  map.put("time_format", Res.string.time_format)
  map.put("title_account", Res.string.title_account)
  map.put("title_activity", Res.string.title_activity)
  map.put("title_dashboard", Res.string.title_dashboard)
  map.put("title_documents", Res.string.title_documents)
  map.put("title_map", Res.string.title_map)
  map.put("title_map_admin", Res.string.title_map_admin)
  map.put("title_settings", Res.string.title_settings)
  map.put("top10_days_subtitle", Res.string.top10_days_subtitle)
  map.put("top10_days_title", Res.string.top10_days_title)
  map.put("uv_index", Res.string.uv_index)
  map.put("validate", Res.string.validate)
  map.put("warn_customer_text_client", Res.string.warn_customer_text_client)
  map.put("warn_customer_text_manager", Res.string.warn_customer_text_manager)
  map.put("you_are_connected", Res.string.you_are_connected)
}
